import React from "react";
import { Popover2InteractionKind } from "@blueprintjs/popover2";
import { MenuItem } from "..";
import { Position } from "../../common/position";
import { MenuItemProps } from "../menu/menuItem";
import "./dropdown.scss";

export const Dropdown = (props: MenuItemProps) => {
  return (
    <MenuItem
      {...props}
      dropdown={true}
      popoverProps={{
        // modifiers: [{ name: "offset", options: { offset: [100, 100] } }], // offset이 안먹어서 주석처리(scss로 해결)
        interactionKind: Popover2InteractionKind.CLICK,
        position: Position.BOTTOM,
      }}
    />
  );
};

